// extracted by mini-css-extract-plugin
export default {"header":"Token_header__lX34W","title":"Token_title__HyJbe","name":"Token_name__3L800","description":"Token_description__merkN","extra":"Token_extra__iSaXM"};